// extracted by mini-css-extract-plugin
export var container = "about-us-module--container--qG3hB";
export var subTitle = "about-us-module--subTitle--altVs";
export var title = "about-us-module--title--9tuX8";